// extracted by mini-css-extract-plugin
export default {"listWrapper":"styles_listWrapper__1Y3mJ"};